const getDefaultState = () => {
    return {
        sendMessageAfter: '',
        menu: {
            model: null,
            showAll: false
        },

        online: {
            noSend: true
        },
        type: 'chat',
        selected_branch_id: null,
        branches: [],
        enable: false,
        working_branches_to_chat: [],
        working_branches_to_call: []
    }
}
// initial state
const state = getDefaultState()

export default {
    namespaced: true,
    state,
    mutations: {
        setWorkingBranchesToChat(arr) {
            state.working_branches_to_chat = arr || []
        },
        resetState(state) {
            Object.assign(state, getDefaultState())
        },
        setApi(state, api) {
            let branches = []
            for (let [key, value] of Object.entries(api.branches)) {
                branches[key] = value
            }

            state.branches = branches
            state.working_branches_to_chat = api.working_branches_to_chat || []
            state.working_branches_to_call = api.working_branches_to_call || []
            state.enable = Boolean(api.options.common.department_choice_enable)
        },
        setShow(state, boolean) {
            state.show = boolean
            if (!boolean) state.type = ''
        },
        setSelectBranchId(state, id) {
            state.selected_branch_id = id
        },
        setOnlineNoSend(state, boolean) {
            state.online.noSend = boolean
        },
        setType(state, string) {
            state.type = string
        },
        setMenuModel(state, val) {
            state.menu.model = val
        },
        setMenuShowAll(state, boolean) {
            state.menu.showAll = boolean
        },
        setSendMessageAfter(state, text) {
            state.sendMessageAfter = text
        }
    },
    actions: {},
    getters: {
        branchShowStartChatActive: (state, getters, rootState, rootGetters) => {
            return (
                rootState.chatActiveBtn === 'chat' &&
                rootGetters.operator.online &&
                state.online.noSend &&
                state.enable
            )
        },
        workingActiveType: (state, getters) => {
            if (state.type === 'chat') return getters.workingToChat
            if (state.type === 'call') return getters.workingToCall
            return []
        },
        workingToChat: state => {
            return state.working_branches_to_chat?.map(id => {
                return state.branches[id]
            })
        },
        workingToCall: state => {
            return state.working_branches_to_call?.map(id => {
                return state.branches[id]
            })
        },
        /**
         * Какие отделы показывать в выборе в зависимости от типа необходимой коммуникации
         * @author Simon Oganesyan
         * @returns {any[]}
         * @param state
         */
        getWorkingBranches: state => type => {
            let branches = state.branches
            if (type === 'chat' || type === 'call') {
                branches = []
                const branches_ids =
                    type === 'chat'
                        ? state.working_branches_to_chat
                        : state.working_branches_to_call
                for (let i = 0; i < state.branches.length; i++) {
                    if (branches_ids.indexOf(parseInt(state.branches[i].id, 0)) !== -1) {
                        branches.push(state.branches[i])
                    }
                }
            }
            return branches
        }
    }
}
